// extracted by mini-css-extract-plugin
export default {"icon":"SharePointComponent_icon__BfHu4"};